import { useEffect, useState } from 'react'
import { HiOutlineFlag } from "react-icons/hi";
import UniversalSelector from './UniversalSelector'

import languageStorage from "../storage/languageStorage"

const getLanguageItems = () => languageStorage.getAllLanguages().map((language) => ({
    id: language.getCode(),
    label: language.getName(),
    description: language.getCode().toUpperCase(),
}))

function LanguageSelector({flash, lang})
{
    const [selectedLanguage, setSelectedLanguage] = useState(languageStorage.getSelectedLanguage())

    useEffect(() => {
        setSelectedLanguage(languageStorage.getSelectedLanguage())
    }, [lang])

    const selectedLanguageName = languageStorage.getLanguage(selectedLanguage).getName()
    const title = lang.tr("current_language_is", selectedLanguageName)

    const selectLanguage = (languageId) => {
        if (languageId === selectedLanguage) {
            return
        }
        languageStorage.selectLanguage(languageId)
        setSelectedLanguage(languageId)
        const language = languageStorage.getLanguage(languageId)
        flash.putMessage(language.tr("language_changed_to", language.getName()), "success")
    }

    return <UniversalSelector
        icon={<HiOutlineFlag />}
        title={title}
        items={getLanguageItems()}
        selectedId={selectedLanguage}
        onSelect={selectLanguage}
        selectionDescriptor={lang.tr("select_language")}
    />
}

export default LanguageSelector
